/**
 * _desayunoImages.ts — Galerías Unsplash verificadas para Desayuno.
 *
 * Solo IDs que responden 200 en images.unsplash.com.
 * Cada plato: 3 fotos distintas (caldo, huevos, chocolate, tamal…).
 */
const u = (photoId: string): string =>
  `https://images.unsplash.com/photo-${photoId}?w=400&h=400&fit=crop&auto=format&q=70`;

const gallery = (...ids: string[]): string[] => ids.map(u);

/** IDs válidos reutilizables (verificados). */
export const DESAYUNO_PHOTO_POOL = [
  "1547592166-23ac45744acd", // caldo / sopa
  "1546069901-ba9599a7e63c", // bowl
  "1504674900247-0877df9cc836", // plato
  "1580554530778-ca36943938b2", // pescado
  "1555939594-58d7cb561ad1", // plato completo
  "1497534446932-c925b458314e", // café
  "1509440159596-0249088772ff", // pan
  "1551218808-94e220e084d2", // desayuno / café
  "1607623814075-e51df1bdc82f", // pollo / carne
  "1550583724-b2692b85b150", // leche / chocolate
  "1598373182133-52452f7691ef", // panadería
  "1565299507177-b0ac66763828", // plato abundante
  "1568901346375-23c9450c58cd", // comida rápida
] as const;

/** Índice alineado con cat_desay_0 … cat_desay_11 */
export const DESAYUNO_GALERIA_BY_INDEX: string[][] = [
  gallery(
    "1547592166-23ac45744acd",
    "1546069901-ba9599a7e63c",
    "1504674900247-0877df9cc836",
  ),
  gallery(
    "1580554530778-ca36943938b2",
    "1547592166-23ac45744acd",
    "1546069901-ba9599a7e63c",
  ),
  gallery(
    "1547592166-23ac45744acd",
    "1555939594-58d7cb561ad1",
    "1546069901-ba9599a7e63c",
  ),
  gallery(
    "1547592166-23ac45744acd",
    "1607623814075-e51df1bdc82f",
    "1546069901-ba9599a7e63c",
  ),
  gallery(
    "1555939594-58d7cb561ad1",
    "1497534446932-c925b458314e",
    "1509440159596-0249088772ff",
  ),
  gallery(
    "1551218808-94e220e084d2",
    "1546069901-ba9599a7e63c",
    "1509440159596-0249088772ff",
  ),
  gallery(
    "1607623814075-e51df1bdc82f",
    "1555939594-58d7cb561ad1",
    "1497534446932-c925b458314e",
  ),
  gallery(
    "1509440159596-0249088772ff",
    "1598373182133-52452f7691ef",
    "1568901346375-23c9450c58cd",
  ),
  gallery(
    "1550583724-b2692b85b150",
    "1497534446932-c925b458314e",
    "1598373182133-52452f7691ef",
  ),
  gallery(
    "1565299507177-b0ac66763828",
    "1546069901-ba9599a7e63c",
    "1598373182133-52452f7691ef",
  ),
  gallery(
    "1547592166-23ac45744acd",
    "1555939594-58d7cb561ad1",
    "1546069901-ba9599a7e63c",
  ),
  gallery(
    "1551218808-94e220e084d2",
    "1546069901-ba9599a7e63c",
    "1509440159596-0249088772ff",
  ),
];
